import VerifySharingPage from "./VerifySharingPage";

export default VerifySharingPage;
